export default __webpack_public_path__ + "static/media/jazzBrunch.161d8087.mp3";